import { ADVISOR_KEY, reportUrls, VERSION } from "../../constants/ApiUrls";
import {
  getData,
  postData,
  postXMLData,
  getXMLData,
  updateData,
} from "../../networkManager/NetworkManager";

export const getReportList = async (userId, caseId, meta) => {
  const params = {
    pageSize: meta?.pageSize ? meta.pageSize : 10,
    pageNumber: meta?.pageNumber ? meta.pageNumber : 1,
    sortOrder: meta?.sortOrder ? meta.sortOrder : "asc",
    filterByDelete: meta?.filterByDelete ? meta.filterByDelete : false,
    filterByMarked: meta?.filterByMarked ? meta.filterByMarked : false,
  };
  return await getData(
    ADVISOR_KEY +
      VERSION +
      `${userId}/${reportUrls.REPORT}?caseId=${caseId}&PageSize=${params.pageSize}&PageNumber=${params.pageNumber}&SortOrder=${params.sortOrder}&marked=${params.filterByMarked}&deleted=${params.filterByDelete}`
  );
};
export const updateReportList = (data, userId, caseId) => {
  return updateData(
    ADVISOR_KEY + VERSION + `${userId}/${reportUrls.REPORT}?caseId=${caseId}`,
    data
  );
};

export const downloadPdfGenerateReport = async (id, t) => {
  return await getXMLData(
    ADVISOR_KEY + VERSION + `${id}/${reportUrls.GENERATE_REPORT}`,
    t("report"),
    ".pdf"
  );
};
